export enum adjustmentType {
	Fixed = 'FIXED',
	Percentage = 'PERCENTAGE'
}
